import React from 'react';
import MySortingCenter from './MySortingCenter';

const ClientListPage: React.FC = () => {
  return (
    <>
      <MySortingCenter />
    </>
  );
};
export default ClientListPage;
